import { render, staticRenderFns } from "./InputTextAreaVariable.vue?vue&type=template&id=dc59b73a&scoped=true"
import script from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
export * from "./InputTextAreaVariable.vue?vue&type=script&lang=js"
import style0 from "./InputTextAreaVariable.vue?vue&type=style&index=0&id=dc59b73a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc59b73a",
  null
  
)

export default component.exports